import React from 'react';

import Icon from '../Icon/Icon';

const WarrantyIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g fillRule='nonzero' fill='none'>
                <path
                    d='m31.87 9.188 20.755 4.374h-.002.002v13.25c-.007 12.303-6.866 21.636-20.577 28l-.048-.15-.048.15C18.406 48.526 11.548 39.34 11.378 27.256l-.003-.444v-13.25h.002-.002l20.496-4.374z'
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='m32.032 13.25 16.332 3.53v10.693c-.119 9.78-5.413 17.234-15.884 22.364l-.48.231V13.257l.032-.007z'
                    fill='#00D1D2'
                />
                <path
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m24.49 31.901 5.184 4.758 12.208-12.422'
                />
            </g>
        </Icon>
    );
};

export default WarrantyIcon;
